import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { AddChildCasesCommand } from './add-child-cases.command';
import { AddChildCasesResult } from './add-child-cases.result';

/**
 * Add child cases use case.
 * Links existing cases as children of the current case.
 */
@Injectable({ providedIn: 'root' })
export class AddChildCasesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: AddChildCasesCommand): Observable<AddChildCasesResult> {
    this._state.setErrorParentChildCases(null);

    return this._repository.addChildCases(command.caseId, command.childCaseIds).pipe(
      tap(() => {
        // Caller is responsible for reloading state after success
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorParentChildCases(error.message || 'Failed to add child cases');
        return throwError(() => error);
      })
    );
  }
}
